// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"f7a80971","990":"f7a80971"}[chunkId] + ".chunk.css";
};